
import axios from "axios";
export const login = (schema) => {
    return new Promise((resolve, reject) => {
        axios.post("/user/login", schema).then(
            (res) => {
                const token = res.data.token;
                localStorage.setItem("user-token", token);
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const addProduct = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post("/product/", schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const updateProduct = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.put(`/product/${id}`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const deleteProduct = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.delete(`/product/${id}`, { data: schema }).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};




export const addSupplier = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post("/supplier/", schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const updateSupplier = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.put(`/supplier/${id}`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const deleteSupplier = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.delete(`/supplier/${id}`, { data: schema }).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};





export const addTransitaire = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post("/transitaire/", schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const updateTransitaire = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.put(`/transitaire/${id}`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const deleteTransitaire = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.delete(`/transitaire/${id}`, { data: schema }).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};



export const addStore = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post("/store/", schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const updateStore = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.put(`/store/${id}`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const deleteStore = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.delete(`/store/${id}`, { data: schema }).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};







export const addUser = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post("/user/", schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const updateUser = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.put(`/user/${id}`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const updateUserProfile = ({ schema}) => {
    return new Promise((resolve, reject) => {
        axios.put(`/user/profile`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const deleteUser = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.delete(`/user/${id}`, { data: schema }).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};





export const addConteneur = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post("/containtype/", schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const updateConteneur = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.put(`/containtype/${id}`, schema).then(
            (res) => {
                // alert(res)
                resolve(res.data);
            },
            (error) => {
                reject(error);
                // alert(error)
                console.log(error)
            }
        );

    });
};
export const deleteConteneur = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.delete(`/containtype/${id}`, { data: schema }).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};


export const addContrat = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post("/contract/", schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const updateContrat = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.put(`/contract/${id}`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const deleteContract = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.delete(`/contract/${id}`, { data: schema }).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};

export const addContratDetails = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post("/contractdetail/", schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const updateContratDetails = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.put(`/contractdetail/${id}`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const deleteContratDetails = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.delete(`/contractdetail/${id}`, { data: schema }).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};











export const addBlDetails = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post("/bl/", schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const updateBlDetails = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.put(`/bl/${id}`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const deleteBlDetails = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.delete(`/bl/${id}`, { data: schema }).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};







export const addContaineurAll = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post("/contain/", schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const updateContaineurAll = ({ schema, id }) => {
    return new Promise((resolve, reject) => {

        axios.put(`/contain/${id}`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const deleteContaineurAll = ({ id }) => {
    return new Promise((resolve, reject) => {
        // alert(id)
        axios.delete(`/contain/${id}`).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};



export const postSendConteneurToStore = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.put(`/contain/${id}`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const postGetConteneurToStore = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.post(`/contain/${id}/acknowledge`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};

export const saveStockLost = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post(`/productloss`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};








export const addCustomer = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post("/customer/", schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const updateCustomer = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.put(`/customer/${id}`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const deleteCustomer = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.delete(`/customer/${id}`, { data: schema }).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};









export const createCard = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post("/cart/", schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
}; export const updateCard = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.put(`/cart/${id}`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};












export const addCartDetails = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post("/cartdetail/", schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const updateCartDetails = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.put(`/cartdetail/${id}`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const deleteCartDetails = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.delete(`/cartdetail/${id}`, { data: schema }).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};

export const postCustomerPayeToCaisse = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.post(`/cart/${id}/purchaseorder`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};


export const postMagasiniserOutProductToStock = ({ schema, }) => {
    return new Promise((resolve, reject) => {
        axios.post(`/cartdetailoutofstore`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};


export const postCaisseCrediteCustomerBalance = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post(`/customertransaction`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};


export const magasinAddPerte = ({ formData }) => {
    return new Promise((resolve, reject) => {
        axios.post("/storeproductlosswithdocument", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};






export const addTaxDetails = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post("/tax/", schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const updateTaxDetails = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.put(`/tax/${id}`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const deleteTaxDetails = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.delete(`/tax/${id}`, { data: schema }).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};




export const addMoneyRequest = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post("/requestusertransaction/", schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const updateMoneyRequest = ({ formData, id }) => {
    return new Promise((resolve, reject) => {
        axios.put(`/requestusertransaction/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const deleteMoneyRequest = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.delete(`/requestusertransaction/${id}`, { data: schema }).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};




export const postVideMoneyToUser = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post("/user/empty-cash/", schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};

export const adminValideComptableDemande = ({ id }) => {
    return new Promise((resolve, reject) => {
        axios.post(`/requestusertransaction/${id}/accept`).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const adminRejectComptableDemande = ({ id }) => {
    return new Promise((resolve, reject) => {
        axios.post(`/requestusertransaction/${id}/reject`).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};


export const adminGiveAccord = ({ id }) => {
    return new Promise((resolve, reject) => {
        axios.post(`/reductionrequest/${id}/accept`).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};





export const adminRejectAccord = ({ id }) => {
    return new Promise((resolve, reject) => {
        axios.post(`/reductionrequest/${id}/reject`).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};



export const magasinValidReturnToStockDemande = ({ id }) => {
    return new Promise((resolve, reject) => {
        axios.post(`/returntostore/${id}/acknowledge`).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const magasinRejectReturnToStockDemande = ({ id }) => {
    return new Promise((resolve, reject) => {
        axios.post(`/returntostore/${id}/reject`).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};


export const adminMakeReductForCustomer = ({ schema }) => {
    // alert('ok')
    return new Promise((resolve, reject) => {
        axios.post(`/reductionrequest`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};



























export const perteSurInventaireAcceptDemande = ({ id }) => {
    return new Promise((resolve, reject) => {
        axios.post(`/storeproductlosswithdocument/${id}/accept`).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const perteSurInventaireRejectDemande = ({ id }) => {
    return new Promise((resolve, reject) => {
        axios.post(`/storeproductlosswithdocument/${id}/reject`).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};






export const sendToCaisse = ({ id }) => {
    return new Promise((resolve, reject) => {
        axios.post(`/cart/${id}/senttocashregister`).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};


export const addCustomerMakeReturnToStoreProduct = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post("/returntostore/", schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const updateCustomerMakeReturnToStoreProduct = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.put(`/returntostore/${id}`, schema).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const deleteCustomerMakeReturnToStoreProduct = ({ schema, id }) => {
    return new Promise((resolve, reject) => {
        axios.delete(`/returntostore/${id}`, { data: schema }).then(
            (res) => {
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error)
            }
        );

    });
};
export const downloadInserErrorData = ({ schema }) => {
    return new Promise((resolve, reject) => {
        axios.post(`/system/exportdocuments`, schema).then(
            (res) => {
                console.log("réponse impression",res.data)
                window.open(res.data.excelLink, "_blank");
                resolve(res.data);
            },
            (error) => {
                reject(error);
                console.log(error);
            }
        );
    });
};


export const logout = () => {
    // alert('logout');
    localStorage.setItem("user-token", "");
    localStorage.setItem("admin-token", "");
    location.reload();
};
